module.exports = __webpack_public_path__ + "static/img/en.9c258ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en.svg
// module id = tc7e
// module chunks = 4